import { useEffect, useState } from 'react';
import { TaskTypeInstructions } from '../types';
import { subscribeToTaskTypeInstructions } from '../services/taskTypeSettings';
import { logGlobalError } from '../utils/globalErrorLogger';

export interface TaskTypeInstructionsState {
  instructions: TaskTypeInstructions | null;
  loading: boolean;
  error: string | null;
}

export function useTaskTypeInstructions(
  taskTypeId: string | null | undefined,
): TaskTypeInstructionsState {
  const [instructions, setInstructions] = useState<TaskTypeInstructions | null>(null);
  const [loading, setLoading] = useState<boolean>(!!taskTypeId);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!taskTypeId) {
      setInstructions(null);
      setLoading(false);
      setError(null);
      return undefined;
    }

    setLoading(true);
    setError(null);
    const unsub = subscribeToTaskTypeInstructions(
      taskTypeId,
      (next) => {
        setInstructions(next);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
        logGlobalError(err, {
          context: 'useTaskTypeInstructions.subscribe',
          metadata: { taskTypeId },
        });
      },
    );

    return () => unsub();
  }, [taskTypeId]);

  return { instructions, loading, error };
}
